import React from 'react';
import Select from 'react-select';
import { dropdownStyle } from 'styles/CustomComponents';

// We need a wrapper component to use react-select with redux-form
// the prop names are in conflict and will map wrong otherwise
const DEFAULT_EMPTY = { value: '', label: '----------' };

const emptyAndProps = (props) => {
  if (props.addEmpty && (props.options.length === 0 || !props.options.includes(DEFAULT_EMPTY))) {
    props.options.unshift(DEFAULT_EMPTY);
  }
  return props;
};

export const PvSelect = (props) => (
  <Select
    {...emptyAndProps(props)}
    styles={dropdownStyle}
    blurInputOnSelect={false} // Fix select on touch devices
  />
);



// WEBPACK FOOTER //
// ./src/components/form/PvSelect.jsx